import { type FC } from "react";

import { AddCampaignOrgUnit } from "src/app/features/Campaign/components/buttons/AddCampaignOrgUnit";
import { AddCampaignTerminals } from "src/app/features/Campaign/components/buttons/AddCampaignTerminals";
import { ContinueButton } from "src/app/features/Campaign/components/buttons/ContinueButton";
import { GenerateButton } from "src/app/features/Campaign/components/buttons/GenerateButton";
import { StopButton } from "src/app/features/Campaign/components/buttons/StopButton";
import { CampaignsSearchForm } from "src/app/features/Campaign/components/forms/CampaignsSearchForm";
import { CampaignsTable } from "src/app/features/Campaign/components/tables/CampaignsTable";
import type { CampaignList } from "src/app/features/Campaign/types/CampaignList";
import { PageLayout, PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { NoAccessLayout } from "../../../../components/AppLayout/components/Content/components/NoAccessLayout";
import { Actions, ResourceManager } from "../../../../components/ResourceManager/ResourceManager";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import type { NoneOwnProps } from "../../../../core/types";

export const CampaignsPage: FC<NoneOwnProps> = () => {
    const table = <CampaignsTable />;
    const searchForm = <CampaignsSearchForm />;
    const hasAccess = canAccess(ResourceName.CAMPAIGNS, "canRead");

    return (
        <PageLayout name="campaigns_page">
            {hasAccess ? (
                <>
                    <PageTitle translationKey="menu.campaigns" />
                    <ResourceManager<CampaignList>
                        useDataGroup
                        dataMapperKey="campaignsTableData"
                        resource={ResourceName.CAMPAIGNS}
                        table={table}
                        searchForm={searchForm}
                        actions={[Actions.FORM_COPY, Actions.EXPORT]}
                        pollingInterval={15000}
                        customActions={[
                            { action: <AddCampaignOrgUnit />, permission: "canWrite" },
                            { action: <AddCampaignTerminals />, permission: "canWrite" },
                            { action: <GenerateButton />, permission: "canWrite" },
                            { action: <ContinueButton />, permission: "canWrite" },
                            { action: <StopButton />, permission: "canWrite" },
                        ]}
                    />
                </>
            ) : (
                <NoAccessLayout />
            )}
        </PageLayout>
    );
};
